"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvmApiConfigSetup = void 0;
var EvmApiConfig_1 = require("./EvmApiConfig");
var EvmApiConfigSetup = /** @class */ (function () {
    function EvmApiConfigSetup() {
    }
    EvmApiConfigSetup.register = function (config) {
        config.registerKey(EvmApiConfig_1.EvmApiConfig.defaultEvmApiChain);
    };
    return EvmApiConfigSetup;
}());
exports.EvmApiConfigSetup = EvmApiConfigSetup;
//# sourceMappingURL=EvmApiConfigSetup.js.map